import React from 'react';
import { useLocalStorage } from 'react-use';
import { useHotkeys } from 'react-hotkeys-hook';
import {
  STORAGE_POS_HOTKEYS_GOTO_LAUNCHER,
  STORAGE_POS_HOTKEYS_GOTO_ORDER,
  STORAGE_POS_HOTKEYS_GOTO_RELOAD,
  STORAGE_POS_HOTKEYS_GOTO_SETTING,
  STORAGE_POS_HOTKEYS_GOTO_USER,
  STORAGE_POS_HOTKEYS_GOTO_WORKBENCH,
  STORAGE_POS_HOTKEYS_OPEN_CASH_DRAW,
} from '@/utils/storage';
import { KeyHandler } from 'hotkeys-js';

export const hotKeysDesc = {
  [STORAGE_POS_HOTKEYS_GOTO_LAUNCHER]: '返回主界面',
  [STORAGE_POS_HOTKEYS_OPEN_CASH_DRAW]: '开钱箱',
  [STORAGE_POS_HOTKEYS_GOTO_WORKBENCH]: '返回工作台',
  [STORAGE_POS_HOTKEYS_GOTO_ORDER]: '查看订单',
  [STORAGE_POS_HOTKEYS_GOTO_USER]: '查看用户',
  [STORAGE_POS_HOTKEYS_GOTO_SETTING]: '系统设置',
  [STORAGE_POS_HOTKEYS_GOTO_RELOAD]: '重新进入系统',
};

export const bindGotoLauncher = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_LAUNCHER, 'f1');
  useHotkeys(key, fn, [key]);
};

export const bindOpenCashDraw = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_OPEN_CASH_DRAW, 'f2');
  useHotkeys(key, fn, [key]);
};

export const bindGotoWorkbench = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_WORKBENCH, 'f3');
  useHotkeys(key, fn, [key]);
};

export const bindGotoOrder = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_ORDER, 'f4');
  useHotkeys(key, fn, [key]);
};

export const bindGotoUser = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_USER, 'f5');
  useHotkeys(key, fn, [key]);
};

export const bindGotoSetting = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_SETTING, 'f6');
  useHotkeys(key, fn, [key]);
};

export const bindReload = (fn: KeyHandler) => {
  const [key, setKey] = useLocalStorage<string>(STORAGE_POS_HOTKEYS_GOTO_RELOAD, 'f9');
  useHotkeys(key, fn, [key]);
};
